import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Add preconnect for Google Fonts
const preconnectGoogle = document.createElement('link');
preconnectGoogle.rel = 'preconnect';
preconnectGoogle.href = 'https://fonts.googleapis.com';
document.head.appendChild(preconnectGoogle);

const preconnectGstatic = document.createElement('link');
preconnectGstatic.rel = 'preconnect';
preconnectGstatic.href = 'https://fonts.gstatic.com';
preconnectGstatic.crossOrigin = 'anonymous';
document.head.appendChild(preconnectGstatic);

// Add Inter font
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap';
document.head.appendChild(fontLink);

// Initialize app with robust error handling
try {
  console.log('🚀 Initializing application...');
  
  const rootElement = document.getElementById('root');
  
  if (!rootElement) {
    throw new Error('Root element not found');
  }
  
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
  
  console.log('✅ Application rendered successfully');
} catch (error) {
  console.error("❌ Fatal application error:", error);
  
  // Create a user-friendly error screen
  const errorMessage = document.createElement('div');
  errorMessage.innerHTML = `
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; padding: 20px; text-align: center; font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;">
      <div style="width: 80px; height: 80px; border-radius: 50%; background-color: #fee2e2; display: flex; align-items: center; justify-content: center; margin-bottom: 24px;">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <h1 style="color: #1f2937; margin-bottom: 16px; font-size: 24px; font-weight: 600;">Unable to load application</h1>
      <p style="color: #4b5563; margin-bottom: 24px; max-width: 500px; line-height: 1.5;">
        We encountered a technical issue while loading the application. Please try refreshing the page.
      </p>
      <button 
        style="background: #1f2937; color: white; border: none; padding: 12px 24px; border-radius: 50px; font-weight: 500; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.backgroundColor='#374151'"
        onmouseout="this.style.backgroundColor='#1f2937'"
        onclick="window.location.reload()"
      >
        Refresh Page
      </button>
      <p style="color: #6b7280; margin-top: 24px; font-size: 14px;">
        Error details: ${error.message || 'Unknown error'}
      </p>
    </div>
  `;
  
  // Replace the entire body content with our error message
  document.body.innerHTML = '';
  document.body.appendChild(errorMessage);
}